import React, { useCallback } from 'react';
import { GuestScaffold } from 'layouts';
import { GenerateTokenForm } from 'components/Pages/Guest/ForgotMyPassword';
import * as S from './styles';

export const ForgotMyPasswordPage: React.FC = () => {
  const Header = useCallback(
    (): JSX.Element => (
      <S.Header>
        <S.Logo>
          <S.LogoImage src={require('assets/images/logo-cooperfibra.png')} />
        </S.Logo>
        <S.Title>Redefina sua senha.</S.Title>
        <S.Subtitle>
          Digite seu e-mail de acesso abaixo e clique no botão ”Enviar”.
          <br />
          Após o envio, você receberá um código no e-mail informado,
          <br />
          que será usado na próxima etapa de redefinição de senha.
        </S.Subtitle>
      </S.Header>
    ),
    []
  );

  return (
    <GuestScaffold>
      <S.PageContainer>
        <S.FormContainer>
          <Header />
          <GenerateTokenForm />
        </S.FormContainer>
        <S.ArtContainer />
      </S.PageContainer>
    </GuestScaffold>
  );
};
